import { render, staticRenderFns } from "./BannerListing.vue?vue&type=template&id=533a16e0&"
import script from "./BannerListing.vue?vue&type=script&lang=js&"
export * from "./BannerListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports